import { Box, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Grid, TextField, Typography } from "@mui/material";
import { trackActivity } from "../../../../utils/mixpanel";
import { useEffect, useState } from "react";
import { AttachementsUpload } from "../../../../shared_elements/components";
import { useDispatch, useSelector } from "react-redux";
import { setFileUploadDetails } from "../../../../shared_elements/actions";
import { formatBytes } from "../../../../utils/fileUpload";
import { backendDateFormat, fieldDateFormat } from "../../../../constants";
import moment from "moment";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { regexConstants } from "../../../../constants/regEx";
import { useParams } from "react-router";
import { globalPostService, globalPutService } from "../../../../utils/globalApiServices";
import { checkApiStatus, getTextFieldRows } from "../../../../utils";
import { enqueueSnackbar } from "notistack";
import { addNotesApi, updateNotesApi } from "../apiService";
import LessMoreTextFieldComp from "../../../../shared_elements/components/LessMoreTextFieldComp";

const NotesCRU = ({ onOpenAttachments, onToggleModal, addEditNotes, modeType, getResponseBack,fileUpload }) => {
    const dispatch = useDispatch();
    const params = useParams();
    const [isLoading, setLoading] = useState(false);
    const [notes, setNotes] = useState(addEditNotes?.data);
    const [uploadedFiles, setUploadedFiles] = useState([]);
    const [error, setError] = useState({});
    const [cleared, setCleared] = useState(false);
    const {storageDetails} = useSelector((state) => state.leases);

    useEffect(() => {
        if (cleared) {
            const timeout = setTimeout(() => {
                setCleared(false);
            }, 1500);
            return () => clearTimeout(timeout);
        }
        return () => { };
    })

    const onAddEditNotes = () => {
        const validationInputs = {
            type: notes?.type?.trim() ? "" : "Please enter Type",
            description: notes?.description ? "" : "Please enter Description",
        };
        const startDate = moment(notes?.start_date);
        const endDate = moment(notes?.end_date);
        if (notes?.start_date && notes?.end_date) {
            if (endDate.isBefore(startDate)) {
                validationInputs.end_date = "End date cannot be before start date";
            }
            if (startDate.isAfter(endDate)) {
                validationInputs.start_date = "Start date cannot be after end date";
            }
        }
        if (Object.keys(validationInputs).every((k) => { return validationInputs[k] === ""; })) {
            setLoading(true);
            if (notes.id) {
                globalPutService(updateNotesApi({ leaseSlug: params?.leaseSlug, id: notes?.id }), notes).then(async (response) => {
                    if (checkApiStatus(response)) {
                        if (uploadedFiles?.length > 0) {
                             fileUpload(notes.slug,'updated');
                        }
                        onToggleModal();
                        getResponseBack();
                        setLoading(false);
                        enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { horizontal: "right", vertical: "top" }, });
                        trackActivity('Item Edited', { page_title: `Edit Notes`, success_msg: response?.data?.message, item_id: notes?.id, payload: notes, response: response?.data })
                    } else {
                        setLoading(false);
                        enqueueSnackbar(response.data.message, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" }, });
                        trackActivity('Item Edited', { page_title: `Edit Notes`, error_msg: response?.data?.message, item_id: notes?.id, payload: notes, response: response?.data })
                    }
                });
            } else {
                globalPostService(addNotesApi({ leaseSlug: params?.leaseSlug }), notes).then(async (response) => {
                    if (checkApiStatus(response)) {
                        if (uploadedFiles?.length > 0) {
                             fileUpload(response?.data?.data.slug,'created');
                        }
                        onToggleModal();
                        getResponseBack();
                        setLoading(false);
                        enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { horizontal: "right", vertical: "top" }, });
                        trackActivity('Item Added', { page_title: `Add Notes`, success_msg: response?.data?.message, item_id: response?.data?.data?.id, payload: notes, response: response?.data })
                    } else {
                        setLoading(false);
                        enqueueSnackbar(response?.data?.message, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" }, });
                        trackActivity('Item Added', { page_title: `Add Notes`, error_msg: response?.data?.message, item_id: null, payload: notes, response: response?.data })
                    }
                });
            }
        } else {
            setError(validationInputs);
            trackActivity(`Item ${modeType === 'add' ? 'Added' : 'Edited'}`, { page_title: `${modeType === 'add' ? 'Add' : modeType === 'edit' ? 'Edit' : 'View'} Notes`, error_msg: validationInputs, })
        }
    };
    const onFieldChange = (key, value) => {
        setNotes({ ...notes, [key]: value })
    }
    const onRestErrorKey = (key) => {
        setError({ ...error, [key]: "" });
    }
    const handleFileChange = (files) => {
        setUploadedFiles(files);
        dispatch(setFileUploadDetails({ attachments: files }))
    };

    const handleItemClicked = (page_type) => {
        trackActivity('Item Clicked', { page_title: `${modeType === 'add' ? 'Add' : modeType === 'edit' ? 'Edit' : 'View'} Notes`, page_type: page_type, })
    }
    return (
        <Dialog
            aria-labelledby="customized-dialog-title"
            className='add-lease-dialog'
            maxWidth='md'
            fullWidth
            open={addEditNotes?.modal}
        >
            <DialogTitle sx={{ m: 0, p: 2 }} className='dialog-header'>
                <Typography className="dialog-header-title">{modeType === 'add' ? 'Add Notes' : modeType === 'edit' ? 'Edit Notes' : 'View Notes'}</Typography>
            </DialogTitle>
            <DialogContent dividers>
                <Grid container spacing={2}>
                    <Grid size={{ md: 4, xs: 12 }}>
                        <TextField
                            required
                            id="type"
                            value={notes?.type || ''}
                            label="Type"
                            variant="outlined"
                            size="small"
                            margin="normal"
                            error={!!error.type}
                            helperText={error.type}
                            slotProps={{ inputLabel: { shrink: true } }}
                            fullWidth
                            disabled={modeType === 'view'}
                            onFocus={() => onRestErrorKey("type")}
                            onChange={(e) => regexConstants.restrictUnicodeCharacters.test(e.target.value) || e.target.value === "" ? e.target.value.length <= 50 ? onFieldChange("type", e.target.value.trimStart()) : e.preventDefault() : ""}
                        />
                    </Grid>
                    <Grid size={{ md: 4, xs: 12 }}>
                        <LocalizationProvider dateAdapter={AdapterMoment}>
                            <DatePicker
                                label="Start Date"
                                value={notes?.start_date ? moment(notes.start_date) : null}
                                onChange={(value) => {
                                    const isValid = moment(value)?.isValid();
                                    const formattedDate = isValid ? moment(value).format(backendDateFormat) : null;
                                    onFieldChange("start_date", formattedDate);
                                    if (isValid) {
                                        onRestErrorKey("start_date");
                                        if (notes?.end_date && !moment(formattedDate).isAfter(moment(notes.end_date))) {
                                            setError(prev => ({ ...prev, start_date: "", end_date: "" }));
                                        }
                                    }
                                }}
                                slotProps={{
                                    textField: {
                                        InputLabelProps: { shrink: true },
                                        size: "small",
                                        margin: "normal",
                                        error: error.start_date || false,
                                        helperText: error.start_date || '',
                                    },
                                    field: {
                                        clearable: true,
                                        onClear: () => {
                                            onFieldChange("start_date", null);
                                            onRestErrorKey("start_date");
                                            setCleared(true);
                                        }
                                    },
                                }}
                                sx={{ width: "100%" }}
                                format={fieldDateFormat}
                                disabled={modeType === 'view'}
                            />
                        </LocalizationProvider>
                    </Grid>
                    <Grid size={{ md: 4, xs: 12 }}>
                        <LocalizationProvider dateAdapter={AdapterMoment}>
                            <DatePicker
                                label="End Date"
                                value={notes?.end_date ? moment(notes.end_date) : null}
                                onChange={(value) => {
                                    const isValid = moment(value)?.isValid();
                                    const formattedDate = isValid ? moment(value).format(backendDateFormat) : null;
                                    onFieldChange("end_date", formattedDate);
                                    if (isValid) {
                                        onRestErrorKey("end_date");
                                        if (notes?.start_date && !moment(formattedDate).isBefore(moment(notes.start_date))) {
                                            setError(prev => ({ ...prev, start_date: "", end_date: "" }));
                                        }
                                    }
                                }}
                                slotProps={{
                                    textField: {
                                        InputLabelProps: { shrink: true },
                                        size: "small",
                                        margin: "normal",
                                        error: error.end_date || false,
                                        helperText: error.end_date || '',
                                    },
                                    field: {
                                        clearable: true,
                                        onClear: () => {
                                            onFieldChange("end_date", null);
                                            onRestErrorKey("end_date");
                                            setCleared(true);
                                        }
                                    },
                                }}
                                sx={{ width: "100%" }}
                                format={fieldDateFormat}
                                disabled={modeType === 'view'}
                            />
                        </LocalizationProvider>
                    </Grid>
                    <Grid size={{ md: 12, xs: 12 }}>
                        <TextField
                            id="description"
                            value={notes?.description || ''}
                            required
                            label="Description"
                            variant="outlined"
                            size="small"
                            margin="normal"
                            fullWidth
                            slotProps={{ inputLabel: { shrink: true }, htmlInput: {maxLength: 255} }}
                            disabled={modeType === 'view'}
                            error={!!error.description}
                            helperText={error.description}
                            multiline
                            rows={getTextFieldRows(notes?.description, 3, 100)}
                            onChange={(e) => {
                                regexConstants.restrictUnicodeCharacters.test(e.target.value) || e.target.value === "" ? onFieldChange("description", e.target.value.trimStart()) : e.preventDefault()
                                setError(prev => ({ ...prev, description: "" }));
                            }}
                            onFocus={() => onRestErrorKey("description")}
                        />
                    </Grid>
                    {modeType === 'view' ?
                        <Grid item size={{ md: 12, xs: 12 }}>
                            <LessMoreTextFieldComp label='Details' value={notes?.remarks || ""} />
                        </Grid> :
                    <Grid size={{ md: 12, xs: 12 }}>
                        <TextField
                            id="details"
                            value={notes?.remarks || ''}
                            label="Details"
                            variant="outlined"
                            size="small"
                            margin="normal"
                            fullWidth
                            slotProps={{ inputLabel: { shrink: true } }}
                            sx={{ '& .MuiInputBase-input': { resize: 'vertical', overflow: 'auto' } }}
                            multiline
                            rows={3}
                            onChange={(e) => {
                                regexConstants.restrictUnicodeCharacters.test(e.target.value) || e.target.value === "" ? onFieldChange("remarks", e.target.value.trimStart()) : e.preventDefault()
                                setError(prev => ({ ...prev, remarks: "" }));
                            }}
                            onFocus={() => onRestErrorKey("remarks")}
                        />
                    </Grid>}
                    <Grid size={{ md: 12, xs: 12 }} sx={{ mt: 3 }}>
                        <Box className="responsive-buttons">
                            {notes?.id && notes?.attachments?.length ?
                                <Button onClick={() => { onOpenAttachments(); handleItemClicked('ViewAttachments Button') }} size='small' variant='outlined' color='primary' sx={{ marginBottom: '10px' }}>{`(${notes?.attachments?.length})Attachments`}</Button> : null
                            }
                            <Button className='available-space-btn' disableRipple size='small' variant='outlined' color='primary'>{`Available Space : ${formatBytes(storageDetails?.remaining_storage)}`}</Button>
                        </Box>
                        {modeType === 'view' ? null : <AttachementsUpload onFileChange={handleFileChange} attachments={notes?.attachments} remainingStorage={storageDetails?.remaining_storage} />}
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions className='dialog-action'>
                <Button className='cancel-btn' disabled={isLoading} variant='outlined' size='small' onClick={() => { onToggleModal(); handleItemClicked('Cancel Button') }}>{modeType === "view" ? "Close" : "Cancel"}</Button>
                {modeType === "view" ? null : <Button variant='contained' className='btn-primary' size='small' disabled={modeType === "view"} onClick={() => { handleItemClicked('Save Button'); onAddEditNotes(); }}> {isLoading ? <CircularProgress color='inherit' size={25} /> : "Save"} </Button>}
            </DialogActions>
        </Dialog>
    )
}

export default NotesCRU;